import React from "react";
import { useNavigate } from "react-router-dom";

const KneeBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .kb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #eff6ff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .kb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .kb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(59, 130, 246, 0.25), rgba(56, 189, 248, 0.08));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .kb-hero {
            grid-template-columns: 1fr;
          }
        }

        .kb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(59, 130, 246, 0.25);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .kb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #3b82f6;
        }

        .kb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .kb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .kb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .kb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .kb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .kb-btnPrimary,
        .kb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .kb-btnPrimary {
          background: #3b82f6;
          color: #eff6ff;
          box-shadow: 0 10px 24px rgba(37, 99, 235, 0.4);
        }

        .kb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(37, 99, 235, 0.55);
        }

        .kb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .kb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .kb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .kb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .kb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .kb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .kb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .kb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .kb-flexCol {
          flex: 1 1 260px;
        }

        .kb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .kb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .kb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .kb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #3b82f6;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .kb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .kb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .kb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .kb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .kb-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .kb-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .kb-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .kb-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* BANNER */
        .kb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .kb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .kb-banner img {
            height: 270px;
          }
        }

        .kb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .kb-bannerText {
          color: #dbeafe;
          font-size: 15px;
          max-width: 420px;
        }

        .kb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .kb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .kb-bannerButtons .primary {
          background: #3b82f6;
          color: #eff6ff;
        }

        .kb-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .kb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .kb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .kb-bottomText strong {
          color: #bfdbfe;
        }

        .kb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .kb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .kb-bottomActions .primary {
          background: #3b82f6;
          color: #eff6ff;
        }

        .kb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .kb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="kb-page">
        <div className="kb-inner">
          {/* HERO */}
          <section className="kb-hero">
            <div>
              <div className="kb-tag">
                <span className="kb-tagDot" />
                Knee · Back of Knee
              </div>
              <h1 className="kb-title">
                Ease back-of-knee tightness so walking, bending, and standing feel more secure.
              </h1>
              <p className="kb-subtitle">
                The back of your knee is more than just a “soft spot”—it’s home to ligaments, capsule,
                meniscus attachments, and supporting muscles. When they&apos;re irritated, you might feel
                tightness, pinching, or a full feeling behind the joint.
              </p>

              <div className="kb-chips">
                <span className="kb-chip">Back-of-knee tightness</span>
                <span className="kb-chip">Pinching with deep bend</span>
                <span className="kb-chip">Post-surgery stiffness</span>
                <span className="kb-chip">Unsteady knee feeling</span>
              </div>

              <div className="kb-ctaRow">
                <button
                  className="kb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a knee visit →
                </button>
                <button
                  className="kb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="kb-heroImgWrap">
              {/* NOTE: hero is JPG on purpose */}
              <img
                src="/content/knee-back/knee_back_hero.jpg"
                alt="Therapist assessing back of knee"
                className="kb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="kb-stripe">
            <div className="kb-sectionTitle">What can go wrong at the back of the knee?</div>
            <p className="kb-sectionSubtitle">
              The back of the knee is where joint capsule, ligaments, meniscus attachments, and nearby muscles
              all meet. It can feel tight, pinchy, or achy when they’re stressed, irritated, or recovering from injury.
            </p>

            <div className="kb-flexRow">
              <div className="kb-flexCol">
                <ul className="kb-list">
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      A feeling of “fullness” or tightness behind the knee with deeper bending.
                    </span>
                  </li>
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      Achiness or pressure after longer periods of standing or walking.
                    </span>
                  </li>
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      Pinching or discomfort with squatting, kneeling, or going down stairs.
                    </span>
                  </li>
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      Residual stiffness after knee surgery or a prior injury.
                    </span>
                  </li>
                </ul>

                <div className="kb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="kb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if this sounds like you →
                  </button>
                  <button
                    className="kb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="kb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/knee-back/knee_back_posterior_joint.png"
                  alt="Manual assessment of posterior knee joint"
                  className="kb-img"
                />
              </div>
            </div>

            <div className="kb-cardGrid">
              <div className="kb-card">
                <div className="kb-cardTitle">Posterior knee joint structures</div>
                <div className="kb-cardText">
                  Ligaments, capsule, and soft tissue at the back of the knee that help keep the joint stable.
                </div>
              </div>
              <div className="kb-card">
                <div className="kb-cardTitle">Meniscus (posterior horns)</div>
                <div className="kb-cardText">
                  Crescent-shaped cartilage that cushions the joint; its back portions can be sensitive with deep bend or twist.
                </div>
              </div>
            </div>
          </section>

          {/* MENISCUS / POSTERIOR STRUCTURES */}
          <section className="kb-stripe">
            <div className="kb-flexRow">
              <div className="kb-flexCol">
                <img
                  src="/content/knee-back/knee_back_meniscus.png"
                  alt="Therapist assessing meniscus-related knee motion"
                  className="kb-img"
                />
              </div>

              <div className="kb-flexCol">
                <div className="kb-sectionTitle">Back-of-knee discomfort with bending or twisting</div>
                <p className="kb-sectionSubtitle">
                  The meniscus and posterior joint structures can feel more noticeable with deep squats, kneeling,
                  or certain twists. PT helps sort out what your knee tolerates—and where to start.
                </p>

                <ul className="kb-list">
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      Pinching or tightness when you go into deeper knee bend (squatting or kneeling).
                    </span>
                  </li>
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      Achiness when twisting or pivoting on that leg, especially on uneven ground.
                    </span>
                  </li>
                  <li>
                    <span className="kb-bullet" />
                    <span>
                      Stiffness after sitting for a while that eases once you walk a bit.
                    </span>
                  </li>
                </ul>

                <div className="kb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="kb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start a knee-friendly plan →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="kb-stripe">
            <div className="kb-sectionTitle">How physical therapy supports the back of the knee</div>
            <p className="kb-sectionSubtitle">
              We look at how your hip, knee, ankle, and strength all contribute to what you feel behind the joint.
            </p>

            <div className="kb-twoColGrid">
              <div className="kb-pillBox">
                <div className="kb-pillTitle">Gentle motion & comfort positions</div>
                <div className="kb-pillText">
                  Guided movements that help the knee move without provoking the back of the joint.
                </div>
              </div>
              <div className="kb-pillBox">
                <div className="kb-pillTitle">Soft-tissue & joint techniques</div>
                <div className="kb-pillText">
                  Hands-on care to reduce guarding and improve how the joint surfaces glide.
                </div>
              </div>
              <div className="kb-pillBox">
                <div className="kb-pillTitle">Strength for support</div>
                <div className="kb-pillText">
                  Targeted strengthening for quads, hamstrings, calves, and hips so the knee doesn&apos;t carry the load alone.
                </div>
              </div>
              <div className="kb-pillBox">
                <div className="kb-pillTitle">Movement & activity tweaks</div>
                <div className="kb-pillText">
                  Practical adjustments for stairs, squatting, and walking that let tissues calm down while you stay active.
                </div>
              </div>
            </div>

            <div className="kb-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="kb-btnPrimary"
                onClick={() => navigate("/appointments")}
              >
                Book a knee session →
              </button>
              <button
                className="kb-btnSecondary"
                onClick={() => navigate("/insurance")}
              >
                Check my insurance
              </button>
            </div>
          </section>

          {/* EXERCISES / VISIT FLOW */}
          <section className="kb-stripe">
            <div className="kb-flexRow">
              <div className="kb-flexCol">
                <img
                  src="/content/knee-back/knee_back_strength.png"
                  alt="Patient doing strengthening for the back of the knee"
                  className="kb-img"
                />
              </div>

              <div className="kb-flexCol">
                <div className="kb-sectionTitle">What a back-of-knee visit may look like</div>

                <div className="kb-twoColGrid">
                  <div className="kb-pillBox">
                    <div className="kb-pillTitle">1. Your story</div>
                    <div className="kb-pillText">
                      We talk about how it started, what movements bother it most, and what you want to get back to.
                    </div>
                  </div>
                  <div className="kb-pillBox">
                    <div className="kb-pillTitle">2. Motion & tolerance</div>
                    <div className="kb-pillText">
                      Gentle checks of bending, straightening, and how your knee tolerates weight-bearing positions.
                    </div>
                  </div>
                  <div className="kb-pillBox">
                    <div className="kb-pillTitle">3. Hands-on & guided movement</div>
                    <div className="kb-pillText">
                      You try specific positions, stretches, and treatment techniques to see what eases symptoms.
                    </div>
                  </div>
                  <div className="kb-pillBox">
                    <div className="kb-pillTitle">4. Simple home plan</div>
                    <div className="kb-pillText">
                      You leave with a small, manageable plan you can repeat at home between visits.
                    </div>
                  </div>
                </div>

                <div className="kb-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="kb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a knee evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="kb-stripe">
            <div className="kb-banner">
              <img
                src="/content/knee-back/knee_back_banner.png"
                alt="Bright PT clinic for knee care"
              />
              <div className="kb-bannerOverlay">
                <div className="kb-bannerText">
                  Knee sessions happen in a calm, one-on-one environment where we match your plan
                  to your comfort level, daily life, and activity goals.
                </div>
                <div className="kb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a knee visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="kb-stripe">
            <div className="kb-bottomStrip">
              <div className="kb-bottomText">
                If you notice sudden severe knee pain, can&apos;t bear weight, see a large swelling or deformity,
                or have back-of-knee pain with calf swelling, warmth, unexplained shortness of breath, or chest pain,{" "}
                <strong>seek urgent or emergency medical care first.</strong> Physical therapy can then help guide
                recovery once serious causes are ruled out.
              </div>
              <div className="kb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule knee PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default KneeBackPT;
